module.exports = __webpack_public_path__ + "img/cate4.d0b40dbf.png";